import {Popover, Tag, Row} from 'antd';

export const UserActiveWidget = ({active, setActive, props}) => {

    const onChange = () => {
        if (setActive) {
            setActive (active ? 0 : 1);
        }
    }

    let tagColor, tagLabel;
    if (active) {
        tagColor = "#0ea133"
        tagLabel = `Active`;
    } else {
        tagColor = "#8f8f8f";
        tagLabel = `Disabled`;
    }

    const popOverContent = `Change value to enable and disable User's System Access`
    return <Popover content={popOverContent}><Row>
        <div style={{cursor: 'pointer'}} onClick={onChange}>
        <Tag color={tagColor}>{tagLabel}</Tag>
        </div>
    </Row></Popover>
}